import { client } from '@api/client';
import { URL } from '@api/urls';

import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import {
	IAllOperatorsOoklaDTO,
	IMeasurementNamesOoklaDTO,
	ITechnologiesOoklaDTO,
} from '@interfaces/platform/dto/ooklaDTO';
import { IOoklaData } from '@interfaces/platform/ookla';

import { TDeviceTypes, TMeasurementTypes } from '@constants/ookla';

const {
	allOperatorsForOokla,
	measurementNamesForOokla,
	datesExistsForOokla,
	technologiesForOokla,
	allOoklaMeasurements,
} = URL;

export interface IGetFilteredOoklaDataParams extends TDefaultDTO {
	deviceType: TDeviceTypes;
	'measuredAt.from': number;
	'measuredAt.to': number;
	measurementNameId: string;
	measurementType: TMeasurementTypes;
	operatorId: string;
	organizationId: string;
	technologyId: string;
}

export const getAllOperatorsOokla = (): Promise<IAllOperatorsOoklaDTO[]> => {
	return client.get(allOperatorsForOokla);
};

export const getMeasurementNamesOokla = (): Promise<IMeasurementNamesOoklaDTO[]> => {
	return client.get(measurementNamesForOokla);
};

export const getTechnologiesOokla = (): Promise<ITechnologiesOoklaDTO[]> => {
	return client.get(technologiesForOokla);
};

export const getDatesExistsOokla = (): Promise<string[]> => {
	return client.get(datesExistsForOokla);
};

export const getAllOoklaData = (): Promise<IOoklaData[]> => {
	return client.post(allOoklaMeasurements, null);
};
